import { GOT_VIDEO } from "./actionTypes";
import changeKey from "./keyAction";
import yangAxios from "../YangAxios";

export const getVideo = id => {
  return async (dispatch, getState) => {
    const keys = getState().apiKey.keys;
    let index = getState().apiKey.currentKey;
    try {
      let res = await yangAxios.get(
        `videos?part=${encodeURI(
          "snippet,contentDetails,statistics"
        )}&id=${id}&key=${keys[index]}`
      );
      res = res.data;
      dispatch(gotVideo(res.items[0]));
    } catch (err) {
      if (err.response && err.response.status === 403 && index < keys.length) {
        dispatch(changeKey(index + 1));
        dispatch(getVideo(id));
      }
      console.log(err);
    }
  };
};

export const gotVideo = data => {
  return {
    type: GOT_VIDEO,
    payload: data
  };
};
